import React from "react";
import ShopCategory from "./[category]";
import { useGlobalSearchParams } from "expo-router";

const Clothing = () => {
    const local = useGlobalSearchParams();

    return <ShopCategory category="clothing" />;
};

export default Clothing;
